import antdDe from "antd/lib/locale-provider/de_DE";
import appLocaleData from "react-intl/locale-data/de";
import enMessages from "../locales/en_US.json";
import deMessages from "../locales/de_DE.json";

const DeLang = {
  messages: {
    ...enMessages,
    ...deMessages
  },
  antd: antdDe,
  locale: 'de',
  data: appLocaleData
};
export default DeLang;
